export const CHECKOUT_STEPS = {
  1: /*i18n*/ 'checkout.header.step.name.1',
  2: /*i18n*/ 'checkout.header.step.name.2',
  3: /*i18n*/ 'checkout.header.step.name.3',
}
